import React, {Component} from 'react';
import {Container} from './styles';
import { Redirect } from 'react-router-dom';
import logo from '../../assets/logo/vermelho@3x.png';
import 'react-activity/dist/react-activity.css';
import api from '../../services/api';
import ModalSelect from './modalSelect';
import Modal from 'react-modal';

export default class SuperUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            restaurantes: [],
            rest: null,
            cidades: [],
            token: null,
            verify: null,
            logado: false,
            carregando: false,
            restClass: 'div-input',
            cityClass: 'div-input',
            type: 'select',
            confirmed: false,
            redirect: null,
            selectOpen: false,
            windowWidth: window.innerWidth,
            tipo: null,
            selectedCity: '',
            selectedRest: ''
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    async componentDidMount() {
        Modal.setAppElement('body');
        window.addEventListener("resize", this.handleResize);
        const token = await localStorage.getItem('@jwt');
        this.setState({token: token})
        this.listCidade()
    }

    componentWillUnmount() {
        window.addEventListener("resize", this.handleResize)
    }

    async decode() {
        let query = window.location.search.slice(1);
        let partes = query.split('=');
        let codigo = decodeURIComponent(partes[1]);
        let codigoDecodado = atob(codigo);
        this.setState({
            jwt: codigoDecodado
        });
        await this.verifyToken(codigoDecodado);
    }

    async listCidade() {
        try {
            var cidades = await api.get('api/citylist', {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            })
            this.setState({cidades: cidades.data})
        } catch (error) {
            console.log('error')
        }
    }

    async logout() {
        try {
            await localStorage.removeItem('@username');
            await localStorage.removeItem('@jwt');
            await localStorage.removeItem('@user');
            await localStorage.removeItem('@rest');
            await localStorage.removeItem('@uf');
            await localStorage.removeItem('@internal');
            await localStorage.removeItem('@suser');
            this.setState({
                redirect: 2
            });
        } catch (e) {
            console.log(e.data);
        }
    }

    async getList(cidade) {
        try {
            const res = await api.get(`api/listselect/${cidade}`, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            })
            this.setState({restaurantes: res.data.lista})
        } catch (error) {
            console.log(error)
        }
    }

    async login(restaurante) {
        try {
            const verif = await api.post('api/susel', {
                    rest: restaurante
                }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }}
            ).then(async (res) => {
                localStorage.setItem('@jwt', res.data.token);
                if(res.data) {
                    var uid = JSON.parse(localStorage.getItem('@user'))
                    const verif = await api.get(`api/verify/${uid.id}`, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }}
                    )
                    localStorage.setItem('@suser', JSON.stringify(verif.data))
                    localStorage.setItem('@rest', JSON.stringify(res.data.isInternal));
                    localStorage.setItem('@uf', res.data.uf);
                    this.setState({logado: true})
                }
            }).catch((erro) => {
                console.log(erro)
            })

        } catch (error) {
            console.log('error')
        }
    }

    selectModal(estado){
        this.setState({
            selectOpen: !estado
        });
      }

    handleModal(e) {
        switch (e) {
            case 0:
            this.setState({ tipo: 0 });
                break;
            case 1:
            this.setState({ tipo: 1 })
                break;
            default:
                break;
        }
        this.selectModal(this.state.selectOpen);
    }

    getData(tipo, id, nome) {
        if (tipo === 0) {
            this.getList(id);
            this.setState({ selectedCity: nome });
        }
        if (tipo === 1) {
            this.setState({ selectedRest: nome, rest: id });
        }
        this.selectModal(this.state.selectOpen);
    }

    render(){
        if(this.state.logado) {
            return (<Redirect to='/' />)
        }
        if(this.state.redirect === 2) {
            return <Redirect to='/login' />
        }
        return (
            <Container>
                <Modal
                    isOpen={this.state.selectOpen}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.selectModal(this.state.selectOpen)}
                    closeModal={() => this.selectModal(this.state.selectOpen)}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930  ? entrada : mobile}
                    contentLabel="Modal"
                    >
                            <ModalSelect
                                tipo={this.state.tipo}
                                cidades={this.state.cidades}
                                restaurantes={this.state.restaurantes}
                                selecionar={(tipo, id, nome) => this.getData(tipo, id, nome)}
                                closeModal={() => this.selectModal(this.state.selectOpen)}/>
                </Modal>
                <img 
                    alt=""
                    src={logo}
                    className="logocompletovermelho" />
                
                <div className="div-bem-vindo">
                            <span
                                className="sejabemvindo"
                                >Selecione o restaurante desejado:</span>
                            {/* <span
                                className="paineldorestaurante"
                                >Painel do Restaurante</span> */}
                        </div>

                <div style={{display: 'flex', flexDirection: 'column', width: '100%', maxWidth: 511, alignSelf: 'center'}}>
                <div className={this.state.cityClass} onClick={
                            () => this.handleModal(0)
                        }>
                                <input
                                    value={this.state.selectedCity === '' ? 'Cidade' : this.state.selectedCity}
                                    name="city"
                                    type="text"
                                    required
                                    style={
                                        this.state.selectedCity === '' ? {
                                            caretColor: 'transparent',
                                            color: '#d3d3d3'
                                        } :
                                        {
                                        caretColor: 'transparent'
                                    }}
                                    />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Escolha uma cidade</span>
                                </label>
                        </div>


                        {this.state.restaurantes.length !== 0 
                        ?

                        <div className={this.state.restClass} onClick={
                            () => this.handleModal(1)
                        }>
                                <input
                                    value={this.state.selectedRest === '' ? 'Restaurante' : this.state.selectedRest}
                                    name="rest"
                                    type="text"
                                    style={
                                        this.state.selectedRest === '' ? {
                                            color: '#d3d3d3',
                                            caretColor: 'transparent'
                                        } :
                                        {
                                        caretColor: 'transparent'
                                    }}
                                    />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Escolha um restaurante</span>
                                </label>
                        </div>
                        :
                        null}
                </div>

                <div className="div-botao">
                    <button 
                        onClick={() => (this.state.selectedRest !== '')
                            ? this.login(this.state.rest) 
                            : null}
                                className={this.state.selectedRest !== ''
                                    ? 'botaologin-active'
                                    : 'botaologin'}
                    >Selecionar</button>
                </div>
                <div className="div-cadastre">
                    <a
                        onClick={async() => await this.logout()}
                        className="Cadastre-seu-restaurante"
                        >Retornar para a tela de início</a>
                </div>
         </Container>
        )
    }
}

const entrada = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '256px'
      }
  };

const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
      }
  };
